module.exports = __webpack_public_path__ + "media/assets/images/tour/3_Tour_4-e83b85f5d738ec3028ca7cb9858156a8.png";